import { render, staticRenderFns } from "./VTSpoiler.vue?vue&type=template&id=79b179e3&"
import script from "./VTSpoiler.vue?vue&type=script&lang=js&"
export * from "./VTSpoiler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports